import { IUser, UserActionTypes } from "../models";
import { EDIT_USER } from "../types";

export default (user: IUser, loggedIn = true): UserActionTypes => ({
    type: EDIT_USER,
    payload: { ...user, loggedIn },
});
